function febre_amarela(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Os sintomas iniciais da febre amarela são: início súbito de febre; calafrios; dor de cabeça intensa; dores nas costas; dores no corpo em geral; náuseas e vômitos; fadiga e fraqueza.",
						"title":"Sintomas",
						"image":"images/games/informs/febre_amarela/sintomas/1.jpg",
					},
					{
						"text":"A maioria das pessoas melhora após estes sintomas iniciais. No entanto, cerca de 15% apresentam um breve período de horas (a um dia) sem sintomas e, então, desenvolvem uma forma mais grave da doença.",
						"title":"Sintomas",
						"image":"images/games/informs/febre_amarela/sintomas/2.jpg",
					},
				],
				"pathImageGame":"midias/images/games/puzzles/febre_amarela/sintomas/2.jpg"
			},
			{
				"informs":[
					{
						"text":"O tratamento da febre amarela é apenas sintomático, com cuidadosa assistência ao paciente que, sob hospitalização, deve permanecer em repouso, com reposição de líquidos e das perdas sanguíneas, quando indicado.",
						"title":"Tratamento",
						"image":"images/games/informs/febre_amarela/tratamento/1.jpg",
					},
					{
						"text":"Nas formas graves, o paciente deve ser atendido em Unidade de Terapia Intensiva (UTI), para reduzir as complicações e o risco de óbito.",
						"title":"Tratamento",
						"image":"images/games/informs/febre_amarela/tratamento/2.jpg",
					},
					{
						"text":"Medicamentos contendo salicilatos devem ser evitados (AAS e Aspirina), já que o uso pode favorecer o aparecimento de manifestações hemorrágicas.",
						"title":"Tratamento",
						"image":"images/games/informs/febre_amarela/tratamento/3.jpg",
					},
				],
				"pathImageGame":"midias/images/games/puzzles/febre_amarela/tratamento/1.jpg"
			},
			{
				"informs":[
					{
						"text":"A vacina é a principal ferramenta de prevenção e controle da febre amarela. O Sistema Único de Saúde (SUS) oferta vacina contra febre amarela para a população.",
						"title":"Profilaxia",
						"image":"images/games/informs/febre_amarela/profilaxia/1.jpg",
					},
					{
						"text":"Toda pessoa que reside em Áreas endêmicas e pessoas que vão viajar para essas áreas devem ser vacinadas. Veja no mapa que este vírus está espalhado por quase todo o território nacional.",
						"title":"Profilaxia",
						"image":"images/games/informs/febre_amarela/profilaxia/2.jpg",
					},
					{
						"text":"A vacina, que é administrada via subcutânea, está disponível durante todo o ano nas unidades de saúde e deve ser administrada pelo menos 10 dias antes do deslocamento para áreas de risco.",
						"title":"Profilaxia",
						"image":"images/games/informs/febre_amarela/profilaxia/3.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/febre_amarela/profilaxia/1.jpg"
			},
			{
				"informs":[
					{
						"text":"No ciclo silvestre da febre amarela, os primatas não humanos (macacos) são os principais hospedeiros e amplificadores do vírus e os vetores são mosquitos com hábitos estritamente silvestres.",
						"title":"Curiosidades",
						"image":"images/games/informs/febre_amarela/curiosidades/1.jpg",
					},
					{
						"text":"Nesse ciclo, o homem participa como um hospedeiro acidental ao adentrar em áreas de mata.",
						"title":"Curiosidades",
						"image":"images/games/informs/febre_amarela/curiosidades/2.jpg",
					},
					{
						"text":"No ciclo urbano, o homem é o único hospedeiro com importância epidemiológica e a transmissão ocorre a partir de vetores urbanos (Aedes aegypti) infectados.",
						"title":"Curiosidades",
						"image":"images/games/informs/febre_amarela/curiosidades/3.jpg",
					},
					{
						"text":"Importante! Os macacos não transmitem a febre amarela! Eles são importantes sentinelas para alerta em regiões onde o vírus da Febre Amarela está circulando.",
						"title":"Curiosidades",
						"image":"images/games/informs/febre_amarela/curiosidades/4.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/febre_amarela/curiosidades/1.jpg"
			}
		]
	};
}

export {febre_amarela};
